module.exports = __webpack_public_path__ + "acd6975bbf2fc292018615019625b5b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/card.png
// module id = 315
// module chunks = 0